import { render, staticRenderFns } from "./bill.vue?vue&type=template&id=2ea7e17e&scoped=true&"
import script from "./bill.vue?vue&type=script&lang=js&"
export * from "./bill.vue?vue&type=script&lang=js&"
import style0 from "./bill.vue?vue&type=style&index=0&id=2ea7e17e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea7e17e",
  null
  
)

export default component.exports